/**
 * Price history modal — always centered fade (not Prestige mobile bottom-sheet slide).
 */
(() => {
  const TAG = 'price-history-modal';

  function definePriceHistoryModal() {
    if (customElements.get(TAG)) return;

    const Modal = customElements.get('x-modal');
    if (!Modal) return;

    class PriceHistoryModal extends Modal {
      createEnterAnimationControls() {
        return this.animate([{ opacity: 0 }, { opacity: 1 }], {
          duration: 200,
          easing: 'ease',
          fill: 'forwards',
        });
      }

      createLeaveAnimationControls() {
        return this.animate([{ opacity: 1 }, { opacity: 0 }], {
          duration: 200,
          easing: 'ease',
          fill: 'forwards',
        });
      }
    }

    customElements.define(TAG, PriceHistoryModal);
  }

  if (customElements.get('x-modal')) {
    definePriceHistoryModal();
  } else {
    customElements.whenDefined('x-modal').then(definePriceHistoryModal);
  }
})();
